<template>
  <div class="container" id="">
    <!-- <div class="bannerPic">
      <img src="../../assets/img/backg.png" style="width: 100%" alt="" /> 
    </div> -->
    <div>
      <div class="backg">
        <div class="backg_top">信息填写</div>
        <van-cell-group>
          <van-field
            v-model="form.name"
            placeholder="请输入真实姓名"
            @input="
              value => {
                form.name = value.replace(
                  /[^\a-\z\A-\Z0-9\u4E00-\u9FA5\· _ ]/g,
                  ''
                );
              }
            "
            maxlength="10"
            @keyboardheightchange="change"
          />
          <van-field
            v-model="form.cardCertnbr"
            maxlength="18"
            @input="
              value => {
                form.cardCertnbr = value.replace(/[\W]/g, '');
              }
            "
            placeholder="请输入身份证号"
          />
          <van-field
            v-model="form.cardMobile"
            maxlength="11"
            type="tel"
            @input="
              value => {
                form.cardMobile = value.replace(/[^\d]+/g, '');
              }
            "
            placeholder="请输入手机号"
          />
          <van-field
            class="lister code2"
            v-model="form.verifyCode"
            maxlength="6"
            placeholder="请输入验证码"
          >
            <template #button>
              <div class="code">
                <div class="codeGroup">
                  <div style="margin-right: 3px" class="line"></div>
                  <div class="subCondeGrpup">
                    <span
                      @click="start"
                      class="codeTxt"
                      v-show="timeStatus == '0001'"
                      >获取验证码</span
                    >
                    <div v-show="timeStatus == '0000'" class="sub">
                      <van-count-down
                        style="color: #f7b500"
                        ref="countDown"
                        millisecond
                        :time="time"
                        :auto-start="false"
                        format="ss"
                        @finish="finish"
                      />&nbsp;&nbsp;&nbsp;
                      <span style="color: #f7b500">秒后重试</span>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </van-field>
        </van-cell-group>
      </div>
      <div class="foot">
        <van-button
          style="margin-top: 50px"
          color="rgb(247,181,0)"
          block
          @click="submit"
          class="btn"
        >
          <span style="color: #333">下一步</span>
        </van-button>
        <div class="infos">
          <van-checkbox v-model="checked" checked-color="#969798" shape="square"
            ><span style="color: #bfc1c9">已阅读并同意</span></van-checkbox
          >
          <span style="color: #f7b500" @click="policyUrl">《授权政策》</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Field } from "vant";
import { CellGroup, CountDown, Toast, Checkbox } from "vant";
import { Button } from "vant";
import { initiateBusinessOrder, baseUrl } from "../../assets/js/api.js";
import { idCode, isPoneAvailable, checkIdcard } from "../../assets/js/common";
Vue.use(Field);
Vue.use(CellGroup);
Vue.use(Button);
Vue.use(CountDown);
Vue.use(Toast);
Vue.use(Checkbox);
export default {
  data() {
    return {
      time: 60000,
      timeStatus: "0001",
      checked: false,
      // 卡信息
      cardInfo: {},
      form: {
        name: "", //名字
        cardMobile: "", //手机号
        cardCertnbr: "", //身份证号
        verifyCode: "", //验证码

        officeCode: "",
        busCode: "",
        channelCode: "",
        channelType: ""
      }
    };
  },
  created() {
    document.title = "立即申请";
    if (sessionStorage.getItem("data")) {
      this.form = JSON.parse(sessionStorage.getItem("data"));
    }

    this.form.officeCode = this.$route.query.officeCode;
    this.form.busCode = this.$route.query.busCode;
    this.form.channelCode = this.$route.query.channelCode;
    this.form.channelType = this.$route.query.channelType;
    this.getCardInfo();
    
  },
  methods: {
    // 获取卡名字和卡图片
    getCardInfo() {
      baseUrl("/common/v1/queryCltBusPhoto", {
        busCode: this.form.busCode,
        channelCode: this.form.channelCode,
        channelType: this.form.channelType
      })
        .then(res => {
          console.log("卡信息↓");
          console.log(res);
          this.cardInfo = res.data;
        })
        .catch(err => {
          console.log(err);
        });
    },

    policyUrl() {
      sessionStorage.setItem("data", JSON.stringify(this.form));
      this.$router.push({
        name: "authorization"
      });
      return;
    },
    // 页面提交
    submit() {
      if (
        this.form.name == "" ||
        this.form.cardMobile == "" ||
        this.form.cardCertnbr == "" ||
        this.form.verifyCode == ""
      ) {
        Toast("数据全为必填项");
        return false;
      }

      if (this.form.name.indexOf(" ") != -1) {
        Toast("姓名不能包含空格");
        return false;
      }

      if (new RegExp("[0-9]").test(this.form.name)) {
        Toast("姓名不能包含数字");
        return false;
      }

      if (isPoneAvailable(this.form.cardMobile) == false) {
        Toast("手机号码不合法，请重新输入");
        return false;
      }

      if (this.form.cardCertnbr.length != 18) {
        Toast("身份证号为18位");
        return false;
      }

      if (idCode(this.form.cardCertnbr) == false) {
        Toast("身份证号输入有误");
        return false;
      }

      if (checkIdcard(this.form.cardCertnbr) == false) {
        Toast("身份证号码输入有误");
        return false;
      }

      if (this.checked == false) {
        Toast("请勾选授权协议");
        return false;
      }

      baseUrl("/business/v1/initiateBusinessOrder", this.form)
        .then(res => {
          console.log(res);
          if (res.data.code == "0000") {
            let handurl = res.data.applyUrl;
            window.location.href = handurl;
            this.form.name = "";
            this.form.cardMobile = "";
            this.form.cardCertnbr = "";
            this.form.verifyCode = "";
            this.timeStatus = "0001";
            this.time = "60000";
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    start() {
      if (this.form.cardMobile == "") {
        Toast("手机号不能为空");
        return falsse;
      }

      if (this.form.cardMobile.length != "11") {
        Toast("手机号输入有误");
        return false;
      }
      this.timeStatus = "0000";

      let obj = {
        phone: this.form.cardMobile,
        commendCode: this.form.officeCode
      };
      baseUrl("/message/v1/creditSend", obj)
        .then(res => {
          console.log(res);
          if (res.data.code == "0000") {
            this.$refs.countDown.start();
          } else {
            Toast(res.data.msg);
          }
        })
        .catch(err => {
          Toast("失败，请稍后再试！");
          console.log(err);
        });
    },
    pause() {
      this.$refs.countDown.pause();
    },
    reset() {
      this.$refs.countDown.reset();
    },
    finish() {
      this.timeStatus = "0001";
      this.time = "60000";
    },
    change(event) {
      alert(JSON.stringify(event.detail));
    }
  }
};
</script>

<style scoped>
.container {
  box-sizing: border-box;
  width: 100%;
  margin: 0 auto;
  max-width: 500px;
  height: 100vh;
  background: url("../../assets/img/backg.png") no-repeat left top #0950e1;
  background-size: 100% 571px;
  padding-top: 78%;
  /* overflow-y: auto; */
}
.codeGroup {
  display: flex;
}
.sub {
  display: flex;
  align-items: center;
  width: 100px;
  margin-left: 5px;
}
.codeTxt {
  color: #368ff9;
  width: 100px;
  margin-left: 5px;
}
.subCondeGrpup {
  width: 80px;
}
.btn {
  width: 96%;
  margin: 0 auto;
}
.infos {
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.line {
  border: 1px solid #368ff9;
}
.cardInfo {
  display: flex;
  align-items: center;
  margin-left: 10px;
}
/deep/ [class*="van-hairline"]::after {
  border-left: 0;
  border-right: 0;
  border-top: 0;
}
.cardPic {
  height: 90px;
  width: 90px;
}
.cardName {
  font-size: 20px;
  font-weight: 600;
  margin-top: 10px;
  margin-left: 10px;
}
.backg {
  background: url("../../assets/img/background.png") no-repeat left -40px;
  background-size: 100% 100%;
  /* height: 70vh; */
  /* position: fixed;
  left: 50%;
  top: 35%; */
  margin: 0 auto;
  /* transform: translateY(70%); */
  width: 95%;
  background: white;
  border-radius: 18px;
  overflow: hidden;
  position: relative;
  top: 30%;
}
.backg_top {
  height: 36px;
  width: 148px;
  margin: 0 auto;
  background: url("../../assets/img/top.png") no-repeat;
  background-size: 148px 36px;
  text-align: center;
  line-height: 36px;
  font-size: 19px;
  color: #ffffff;
  font-weight: 500;
}
.van-cell {
  line-height: 30px;
}
.foot {
  position: relative;
  top: 35%;
}
</style>
